import { NAV_MENU_TYPE } from '../types';
import NavbarCommunity from '../assets/navbar-community.svg';
import NavbarEdit from '../assets/navbar-edit.svg';
import NavbarValut from '../assets/navbar-vault.svg';
import Agents from '../assets/agents.svg';
import Customize from '../assets/customize.svg';

export const MENU_LIST_CONFIG = [
    {
        type: NAV_MENU_TYPE.HOME,
        icon: NavbarEdit,
        link: '/home',
        module: NAV_MENU_TYPE.HOME,
    },
    {
        type: NAV_MENU_TYPE.SEARCH_TASK,
        icon: 'SolidSearchLeft',
        link: '/search-task',
        router: '/search-task',
        module: NAV_MENU_TYPE.SEARCH_TASK,
        authKey: 'isUserLogin',
    },
    {
        type: NAV_MENU_TYPE.AGENT_LIST,
        icon: Agents,
        link: '/agent-list',
        router: '/agent-list',
        module: NAV_MENU_TYPE.AGENT_LIST,
    },
    {
        type: NAV_MENU_TYPE.CUSTOMIZE_LIST,
        icon: Customize,
        link: '/customize-list',
        router: '/customize-list',
        module: NAV_MENU_TYPE.CUSTOMIZE_LIST,
    },
    {
        type: NAV_MENU_TYPE.CUSTOM_AGENT,
        icon: 'SolidInsightsTechnology',
        link: '/explore',
        module: NAV_MENU_TYPE.CUSTOM_AGENT,
        authKey: 'custom_table_permission',
    },
    {
        type: NAV_MENU_TYPE.AI_STUDIO,
        icon: 'SolidChartTopipc',
        link: '/ai-studio',
        module: NAV_MENU_TYPE.AI_STUDIO,
        authKey: 'ai_agent_studio',
    },
    {
        type: NAV_MENU_TYPE.MONITOR,
        icon: 'SolidAim',
        link: '/monitor',
        module: NAV_MENU_TYPE.MONITOR,
    },
    {
        type: NAV_MENU_TYPE.WORK_PROJECT,
        icon: 'SolidFolderMany',
        link: '/rd/#/graph',
        router: '/graph',
        module: NAV_MENU_TYPE.WORK_PROJECT,
        authKey: 'work_project',
    },
    {
        type: NAV_MENU_TYPE.VAULT,
        icon: NavbarValut,
        link: '/vault',
        module: NAV_MENU_TYPE.VAULT,
        authKey: 'vault_permission',
    },
    {
        type: NAV_MENU_TYPE.COMMUNITY,
        icon: NavbarCommunity,
        link: '/rd-gallery',
        module: NAV_MENU_TYPE.COMMUNITY,
    }
];

export const INCOGNITO_MENU_ITEM = {
    type: NAV_MENU_TYPE.INCOGNITO,
    icon: 'SolidSecutiry',
}

export const EVENTS_CONFIG = {
    [NAV_MENU_TYPE.HOME]: 'SS Seek Search',
    [NAV_MENU_TYPE.WORK_PROJECT]: 'SS Work Project',
    [NAV_MENU_TYPE.TECH_MIND]: 'SS Idea AI',
    [NAV_MENU_TYPE.RD_TECH_MIND]: 'SS RD Tech Mind',
    [NAV_MENU_TYPE.TECH_FMEA]: 'SS Tech FMEA',
    [NAV_MENU_TYPE.TECH_RESEARCH]: 'SS Project',
    [NAV_MENU_TYPE.IDEA_EXPLORATION]: 'SS Idea AI',
    [NAV_MENU_TYPE.TRIZ_MIND]: 'SS TRIZ',
    [NAV_MENU_TYPE.TRIZ_PRO]: 'SS TRIZ',
    [NAV_MENU_TYPE.TRIZ_SKILL]: 'SS TRIZ',
    [NAV_MENU_TYPE.DEEPCOST]: 'SS DeepCost',
};
